import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import { useMarkAsReadConversation } from 'modules/ats/hooks/conversations/useMarkAsReadConversation'

interface Props {
  conversationId: number
  accessId: number
}

const MarkAsReadButtonComponent = ({ conversationId, accessId }: Props) => {
  const { loading, markAsReadConversation } = useMarkAsReadConversation()

  const onClick = async () => {
    await markAsReadConversation({
      id: conversationId,
      accessId: accessId,
    })
  }

  return (
    <Button onClick={onClick} type="secondary" disabled={loading}>
      {i18n.t('ats.messages.marks_as_read')}
    </Button>
  )
}

export const MarkAsReadButton = observer(MarkAsReadButtonComponent)
